import React from 'react';
import './subscription.css';

const Subscription = ({ data }) => {
    return (
        <div className="subscription item">
            <div className="subscription__bar" style={{ backgroundColor: data.type_color }} />
            <div className="subscription__type">{ data.type }</div>
            <div className="subscription__coach">{ data.coach }</div>
            <div className="subscription__freeze">{ data.freeze_info }</div>
            <div className="subscription__constraint">{ data.time_constraint }</div>
            <div className="subscription__address">{ data.address }</div>
            <div className="subscription__data">
                <div className="subscription__workouts">
                    <div className="subscription__workouts-count">{ data.workouts_left }</div>
                    <div className="subscription__workouts-caption">{ data.workouts_declination }</div>
                </div>
                <div className="subscription__expire">
                    <div className="subscription__expire-caption">{ data.expire_title }</div>
                    <div className="subscription__expire-date">{ data.expire_value }</div>
                </div>
            </div>
        </div>
    );
};

export default Subscription;